import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Button, Grid, MenuItem } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import InputForm from "../../../../partials/inputForm";

import Loading from "../../../loading";
import Snackbar from "../../../snackbar";
import { settingStyle } from "./styles";
import { isJsonString } from "../../../../utils/setting";
const typeFormatDatetime = ["24h", "12h"];

class Setting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceSetting: {
        prefixItem: "",
        totalItem: 0,
        prefixEmployee: "",
        totalEmployee: 0,
        prefixCustomer: "",
        totalCustomer: 0,
        formatDatetime: "24h",
      },
    };
  }
  async componentDidMount() {
    this.loading.startLoading();
    await this.props.getServiceSetting();
    this.setState({ serviceSetting: this.props.serviceSetting }); // serviceSetting lấy từ page/main
    this.loading.stopLoading();
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.serviceSetting !== nextProps.serviceSetting) {
      this.setState({ serviceSetting: nextProps.serviceSetting });
    }
  }
  handleChange = (event) => {
    const { serviceSetting = {} } = this.state;
    serviceSetting[event.target.name] = event.target.value;
    this.setState({ serviceSetting });
  };
  handleSubmit = () => {
    let { serviceSetting = {} } = this.state;
    this.props.handleUpdate("setting", serviceSetting);
  };
  render() {
    const { classes, t, disabled = false } = this.props;
    let { serviceSetting = {} } = this.state;
    return (
      <div>
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />

        {/* <Grid container spacing={0} className={classes.group}>
                    <Grid item xs={12} ms={12} md={12}>     
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6} md={6}>
                                <InputForm 
                                    fullWidth
                                    disabled={disabled}
                                    label={t('service_ownerspa_servicedetail_service_setting_prefix_menu')}
                                    name="prefixMenu"
                                    id="prefixMenu"
                                    value={serviceSetting.prefixMenu}
                                    onChange={this.handleChange}
                                />
                            </Grid>        
                            <Grid item xs={12} sm={6} md={6}>
                                <InputForm
                                    fullWidth
                                    disabled={disabled}
                                    name="totalMenu"
                                    id="totalMenu"
                                    type="number"
                                    label={t('service_ownerspa_servicedetail_service_setting_total_menu')}
                                    value={Number(serviceSetting.totalMenu)}
                                    onChange={this.handleChange}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid> */}
        <Grid container spacing={0} className={classes.group}>
          <Grid item xs={12} ms={12} md={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={6}>
                <InputForm
                  fullWidth
                  disabled={disabled}
                  label={t(
                    "service_ownerspa_servicedetail_service_setting_prefix_menu_item"
                  )}
                  name="prefixItem"
                  id="prefixItem"
                  value={serviceSetting.prefixItem}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputForm
                  fullWidth
                  disabled={disabled}
                  name="totalItem"
                  id="totalItem"
                  type="number"
                  label={t(
                    "service_ownerspa_servicedetail_service_setting_total_menu_item"
                  )}
                  value={Number(serviceSetting.totalItem)}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={0} className={classes.group}>
          <Grid item xs={12} ms={12} md={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={6}>
                <InputForm
                  fullWidth
                  disabled={disabled}
                  label={t(
                    "service_ownerspa_servicedetail_service_setting_prefix_employee"
                  )}
                  name="prefixEmployee"
                  id="prefixEmployee"
                  value={serviceSetting.prefixEmployee}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputForm
                  fullWidth
                  disabled={disabled}
                  name="totalEmployee"
                  id="totalEmployee"
                  type="number"
                  label={t(
                    "service_ownerspa_servicedetail_service_setting_total_employee"
                  )}
                  value={Number(serviceSetting.totalEmployee)}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={0} className={classes.group}>
          <Grid item xs={12} ms={12} md={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={6} md={6}>
                <InputForm
                  fullWidth
                  disabled={disabled}
                  label={t(
                    "service_ownerspa_servicedetail_service_setting_prefix_customer"
                  )}
                  name="prefixCustomer"
                  id="prefixCustomer"
                  value={serviceSetting.prefixCustomer}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <InputForm
                  fullWidth
                  disabled={disabled}
                  name="totalCustomer"
                  id="totalCustomer"
                  type="number"
                  label={t(
                    "service_ownerspa_servicedetail_service_setting_total_customer"
                  )}
                  value={Number(serviceSetting.totalCustomer)}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={0} className={classes.group}>
          <Grid container spacing={0} className={classes.group}>
            <Grid item xs={12} ms={12} md={12}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={6}>
                  <InputForm
                    disabled={disabled}
                    select
                    label={t("service_ownerspa_servicedetail_format_datetime")}
                    value={serviceSetting.formatDatetime}
                    onChange={this.handleChange}
                    name="formatDatetime"
                    id="formatDatetime"
                    margin="normal"
                    variant="outlined"
                  >
                    {typeFormatDatetime.map((type, index) => {
                      return (
                        <MenuItem key={index} value={type}>
                          {t(type)}
                        </MenuItem>
                      );
                    })}
                  </InputForm>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} ms={12} md={12}>
            <Button
              disabled={disabled}
              onClick={this.handleSubmit}
              color="primary"
              size="large"
              variant="contained"
              component="span"
              className={classes.button}
            >
              {" "}
              {t("service_ownerspa_servicedetail_update")}{" "}
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Setting.propTypes = {};
const mapState = (state) => ({
  serviceSetting: state.serviceSetting.serviceSetting,
  role: state.user.user.roleId.role,
  ownerCode: state.service.service.userCode,
});
const mapDispatch = (dispatch) => ({
  getServiceSetting: dispatch.serviceSetting.getServiceSetting,
});
export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(withStyles(settingStyle, { withTheme: 0 })(Setting))
);
